import { Button } from '@chakra-ui/react'
import { Box, HStack, Progress, Text, VStack } from '@chakra-ui/react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import {
  DropzoneVariant,
  useDropzoneStyles,
} from '~/components/shared/componentStyles/Dropzone.style'
import { formatFileSize } from '~/utils/common'

import Content from './Content'
import { Context } from './Context'

export default function Container() {
  const {
    currentVariant,
    props: { allowMultiple },
  } = useContext(Context)

  return (
    <VStack alignItems="flex-start" width="100%">
      {allowMultiple ? <SizeGauge /> : null}
      <Dropzone />
      {allowMultiple && currentVariant === DropzoneVariant.FileAccepted ? (
        <Toolbar />
      ) : null}
    </VStack>
  )
}

function Dropzone() {
  const {
    currentVariant,
    dropzoneState: { getInputProps, getRootProps },
    props: { boxProps },
    ref,
  } = useContext(Context)

  const styles = useDropzoneStyles({
    variant: currentVariant,
  })

  return (
    <Box
      maxHeight="30vh"
      overflow="auto"
      ref={ref}
      css={{ ...styles.container }}
      {...boxProps}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Content />
    </Box>
  )
}

function SizeGauge() {
  const {
    props: { maxFileSize: sizeLimit },
    totalSize,
  } = useContext(Context)
  const { t } = useTranslation()

  const readingPercentage = Math.min((totalSize / sizeLimit) * 100, 100)

  const color =
    (readingPercentage >= 100 && 'red') ||
    (readingPercentage >= 80 && 'orange') ||
    'green'

  return (
    <VStack align="start" width="100%">
      <HStack justifyContent="space-between" width="100%">
        <Text fontSize="x-small">
          {t('sizeGauge.totalSize', {
            totalSize: formatFileSize(totalSize),
            sizeLimit: formatFileSize(sizeLimit),
          })}
        </Text>
        {readingPercentage === 100 ? (
          <Text fontSize="x-small">
            {t('sizeGauge.exceededSize', {
              exceededSize: formatFileSize(totalSize - sizeLimit),
            })}
          </Text>
        ) : null}
      </HStack>
      <Progress.Root
        colorPalette={color}
        size="sm"
        value={readingPercentage}
        width="100%"
      >
        <Progress.Track backgroundColor="lightgrey" borderRadius="md">
          <Progress.Range transition="ease-in-out 0.3s" />
        </Progress.Track>
      </Progress.Root>
    </VStack>
  )
}

function Toolbar() {
  const { potentialDuplicatePaths, resetAllState } = useContext(Context)
  const { t } = useTranslation()
  return (
    <HStack justifyContent="space-between" width="100%">
      <Button size="sm" variant="plain" onClick={resetAllState}>
        {t('toolbar.clearAll')}
      </Button>
      {potentialDuplicatePaths.length ? (
        <Text color="var(--chakra-colors-warning)" fontSize="x-small">
          {t('toolbar.potentialDuplicates')}
        </Text>
      ) : null}
    </HStack>
  )
}
